function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.791 17.752L41.31 29.784c1.013.633.633 2.153-.507 2.28L30.544 33.71l-5.067 9.118c-.506.887-2.026.76-2.152-.38l-4.433-23.43c-.127-1.013 1.013-1.773 1.9-1.266z",
  fill: "#000"
});

function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _ref);
}

export default SvgCursor;